<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" /> Search Index Settings
            <button
              class="pull-right btn btn-sm btn-danger delete-index-all"
              style="margin-left: 15px;"
              @click="deleteIndexForAll"
            >
              Delete index for all type
              <span
                class="btn-loader"
                style="display: none;"
              />
            </button>
            <button
              class="pull-right btn btn-sm btn-success update-index-all"
              style="margin-left: 15px;"
              @click="updateIndexForAll"
            >
              Create index for all type
              <span
                class="btn-loader"
                style="display: none;"
              />
            </button>
            <button
              class="pull-right btn btn-sm btn-primary reload-source"
              @click="reloadSource"
            >
              Update index data
              <span
                class="btn-loader"
                style="display: none;"
              />
            </button>
          </div>

          <div class="card-block spinner-parent">
            <spinner
              ref="spinner"
              size="md"
              text="Loading ..."
            />

            <div class="table-responsive">
              <table class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Count</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in types"
                    :key="item.type"
                    :data-type="item.type"
                  >
                    <td>{{ item.type }}</td>
                    <td>{{ item.documents_count }}</td>
                    <td class="table-list__cell--narrow">
                      <button
                        class="btn btn-primary btn-sm"
                        @click="updateIndexForType(item.type)"
                      >
                        Update index
                        <span
                          class="btn-loader"
                          style="display: none;"
                        />
                      </button>
                      <button
                        class="btn btn-danger btn-sm"
                        @click="deleteIndexForType(item.type)"
                      >
                        Delete index
                        <span
                          class="btn-loader"
                          style="display: none;"
                        />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'Search',

  data() {
    return {
      types: null,
    };
  },

  watch: {
    offset() {
      this.getSource();
    },
  },

  mounted() {
    this.getSource();
  },

  methods: {
    getSource() {
      const $btnLoader = $('.reload-source .btn-loader');
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}search/indices/egw`)
        .then((response) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.types = response.data.egw;
          $btnLoader.hide();
        })
        .catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          $btnLoader.hide();
          console.error(error);
        });
    },
    reloadSource() {
      const $btnLoader = $('.reload-source .btn-loader');
      $btnLoader.show();
      this.getSource();
    },
    updateIndexForType(type) {
      if (window.confirm(`Do yo really want to update search index for all ${type}`)) {
        const $btnLoader = $(`.entities tr[data-type="${type}"] .btn-primary .btn-loader`);
        $btnLoader.show();
        this.$apiHttp.post(`${this.$config.app_api.prefix}search/documents/${type}`)
          .then(() => {
            $btnLoader.hide();
          })
          .catch((error) => {
            $btnLoader.hide();
            console.error(error);
          });
      }
    },
    deleteIndexForType(type) {
      if (window.confirm(`Do yo really want to delete search index for ${type}`)) {
        const $btnLoader = $(`.entities tr[data-type="${type}"] .btn-danger .btn-loader`);
        $btnLoader.show();
        this.$apiHttp.delete(`${this.$config.app_api.prefix}search/documents/${type}`)
          .then(() => {
            $btnLoader.hide();
          })
          .catch((error) => {
            $btnLoader.hide();
            console.error(error);
          });
      }
    },
    updateIndexForAll() {
      if (window.confirm('Do yo really want to update search index for all entities')) {
        const $btnLoader = $('.update-index-all .btn-loader');
        $btnLoader.show();
        this.$apiHttp.post(`${this.$config.app_api.prefix}search/indices/egw`)
          .then(() => {
            $btnLoader.hide();
          })
          .catch((error) => {
            $btnLoader.hide();
            console.error(error);
          });
      }
    },
    deleteIndexForAll() {
      if (window.confirm('Do yo really want to delete search index for all entities')) {
        const $btnLoader = $('.delete-index-all .btn-loader');
        $btnLoader.show();
        this.$apiHttp.delete(`${this.$config.app_api.prefix}search/indices/egw`)
          .then(() => {
            $btnLoader.hide();
          })
          .catch((error) => {
            $btnLoader.hide();
            console.error(error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Search.vue?6a28f80c